import { Helmet } from 'react-helmet-async';
import { PageHeader } from 'components/page-header';
import { pageTitle } from 'utils/page-title';
import { CleanupLogTable } from './cleanup-log';
import styles from './cleanup-log.module.scss';

/**
 * Read-only drill-down into entity-library clean-up: one row per merge action,
 * who retired which entity into what, with the signals a lead QCs the match by.
 * The detail complement to the Entity Library Analytics side panel.
 * @return {JSX.Element} The page
 */
export function EntityCleanupLogPage() {
  return (
    <>
      <Helmet>
        <title>{pageTitle('Entity Library Clean-up Log')}</title>
      </Helmet>
      <PageHeader
        breadcrumbs={[]}
        title="Entity Library Clean-up Log"
        titleDetail={
          <span className={styles.subtitle}>
            QC of dedupe & reconcile decisions
          </span>
        }
        actions={null}
        compactContent
      />
      <div className={styles.contentWrapper}>
        <CleanupLogTable />
      </div>
    </>
  );
}
